export default __webpack_public_path__ + "static/media/logo.7bc4a789.png";